module.exports = __webpack_public_path__ + "static/media/ytmusic.a2b985ba.jpg";